import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { H3, Paragraph, Text } from 'components/atoms/Typography/Typography';
import {Button} from 'components/core/Button';
import Expand from 'components/atoms/Expand/Expand';
import Plus from 'components/svg/Plus';
import Minus from 'components/svg/Minus';
import { withStateHandlers } from 'recompose';
import { ChevronDown } from 'components/svg';
import MarkdownWrapper from 'components/search/MarkdownWrapper/MarkdownWrapper';
import './FAQItem.scss';
export const enhance = withStateHandlers(
	{
		answerExpanded: false,
	},
	{
		handleExpandAnswer:
			({ answerExpanded }) =>
			() => ({ answerExpanded: !answerExpanded }),
	}
);

export function FAQItem({
	className,
	question,
	answer,
	even,
	handleExpandAnswer,
	answerExpanded,
	icon,
	carotIcon,
}) {
	return (
		<div className={classnames(className, 'faq-item', even)}>
			<div
				onClick={handleExpandAnswer}
				onKeyDown={handleExpandAnswer}
				role="button"
				tabIndex={0}
				className={classnames(className, 'faq-item-question')}
			>
				{icon ? (
					<div className="icon-question-wrapper">
						{icon && (
							<img
								src={icon}
								alt=""
								width="40"
								height="40"
							/>
						)}
						<Paragraph
							size="small"
							className="question"
						>
							<MarkdownWrapper
								icon={icon}
								content={[question]}
							/>
						</Paragraph>
					</div>
				) : (
					<H3 className="sf-type-medium sf-type question">
						{question}
					</H3>
				)}

				<Button
					primary={false}
					className="extend-button"
					aria-expanded={answerExpanded}
					aria-controls={`faq-answer-${question.replace(/\s+/g, '-').toLowerCase()}`}
					aria-label={answerExpanded ? 'Collapse answer' : 'Expand answer'}
				>
					<div
						className={carotIcon ? 'carot-icon' : 'plus-minus-icon'}
					>
						{carotIcon ? (
							<ChevronDown reverse={answerExpanded} />
						) : answerExpanded ? (
							<Minus />
						) : (
							<Plus />
						)}
					</div>
				</Button>
			</div>
			<Expand
				showing={answerExpanded}
				preserve
			>
				<div className="faq-item-answer">
					<Text
						last
						className="answer"
					>
						<MarkdownWrapper content={[answer]} additionalProps={{ paragraph: { color: 'black', weight: 'standard' } }} />
					</Text>
				</div>
			</Expand>
		</div>
	);
}

FAQItem.propTypes = {
	className: PropTypes.string,
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired,
	even: PropTypes.bool,
	handleExpandAnswer: PropTypes.func,
	answerExpanded: PropTypes.bool,
	icon: PropTypes.string,
	carotIcon: PropTypes.bool,
};

export default enhance(FAQItem);
